import { gql } from '@apollo/client'
import fragments from 'graphql/fragments'

// Remote
export const ADD_CALCULATION_NODE = gql`
  mutation AddCalculationNode(
    $modellingProjectId: ID!
    $parentId: ID
    $roundInput: RoundInput!
    $payOutInputs: [PayOutInput!]!
    $exitDate: Date!
  ) {
    addCalculationNode(
      modellingProjectId: $modellingProjectId
      parentId: $parentId
      roundInput: $roundInput
      payOutInputs: $payOutInputs
      exitDate: $exitDate
    ) {
      ...ModellingProject
    }
  }
  ${fragments.modellingProject}
`

export const ADD_CALCULATION_NODE_SINGLE = gql`
  mutation AddCalculationNodeSingle(
    $modellingProjectId: ID!
    $parentId: ID
    $roundInput: RoundInput!
    $payOutInputs: [PayOutInput!]!
    $exitDate: Date!
  ) {
    addCalculationNodeSingle(
      modellingProjectId: $modellingProjectId
      parentId: $parentId
      roundInput: $roundInput
      payOutInputs: $payOutInputs
      exitDate: $exitDate
    ) {
      ...CalculationNodeRec
    }
  }
  ${fragments.calculationNodeRec}
`

export const UPDATE_CALCULATION_NODE_EXIT_DATE = gql`
  mutation UpdateCalculationNodeExitDate(
    $modellingProjectId: ID!
    $calculationNodeId: ID!
    $exitDate: Date!
  ) {
    updateCalculationNodeExitDate(
      modellingProjectId: $modellingProjectId
      calculationNodeId: $calculationNodeId
      exitDate: $exitDate
    ) {
      ...ModellingProject
    }
  }
  ${fragments.modellingProject}
`

export const UPDATE_CALCULATION_NODE_SIMULATE_AD = gql`
  mutation UpdateCalculationNodeSimulateAD(
    $modellingProjectId: ID!
    $calculationNodeId: ID!
    $simulateAD: Boolean!
  ) {
    updateCalculationNodeSimulateAD(
      modellingProjectId: $modellingProjectId
      calculationNodeId: $calculationNodeId
      simulateAD: $simulateAD
    ) {
      ...ModellingProject
    }
  }
  ${fragments.modellingProject}
`

export const UPDATE_CALCULATION_NODE_PAYOUTS = gql`
  mutation UpdateCalculationNodePayouts(
    $modellingProjectId: ID!
    $calculationNodeId: ID!
    $payOutInputs: [PayOutInput!]!
  ) {
    updateCalculationNodePayouts(
      modellingProjectId: $modellingProjectId
      calculationNodeId: $calculationNodeId
      payOutInputs: $payOutInputs
    ) {
      ...ModellingProject
    }
  }
  ${fragments.modellingProject}
`

export const SAVE_CALCULATION_NODE = gql`
  mutation SaveCalculationNode(
    $modellingProjectId: ID!
    $calculationNodeId: ID!
    $roundInput: RoundInput!
    $payOutInputs: [PayOutInput!]!
    $exitDate: Date!
  ) {
    saveCalculationNode(
      modellingProjectId: $modellingProjectId
      calculationNodeId: $calculationNodeId
      roundInput: $roundInput
      payOutInputs: $payOutInputs
      exitDate: $exitDate
    ) {
      ...ModellingProject
    }
  }
  ${fragments.modellingProject}
`

export const DELETE_CALCULATION_NODE = gql`
  mutation DeleteCalculationNode($modellingProjectId: ID!, $calculationNodeId: ID!) {
    deleteCalculationNode(
      modellingProjectId: $modellingProjectId
      calculationNodeId: $calculationNodeId
    ) {
      ...ModellingProject
    }
  }
  ${fragments.modellingProject}
`

const mutations = {
  addRemote: ADD_CALCULATION_NODE,
  saveRemote: SAVE_CALCULATION_NODE,
  deleteRemote: DELETE_CALCULATION_NODE,
  saveOp: 'saveCalculationNode',
  addOp: 'addCalculationNode',
  deleteOp: 'deleteCalculationNode',
}

export const calculationNodeQueries = { ...mutations }
